import toast from "react-hot-toast";

export function useToast() {
  return {
    showToast: toast,
  };
}
export { Toaster } from "react-hot-toast";
